export default "__VITE_ASSET__ClpQpLX6__"